import { Postponement } from "../interfaces";
import API_ENDPOINTS from "./config";

export async function savePostponement(
  matchId: number,
  body: Postponement
): Promise<any> {
  const url = API_ENDPOINTS.postponement(matchId.toString());
  const res = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
  });
  if (!res.ok) {
    throw new Error(await res.text());
  }
  return await res.json();
}
